// js
import React, { Component } from 'react';
import dsaView, {defaultPropTypes} from './dsaView';
import SourcesHeader from '../components/sources/SourcesHeader';
import SourcesHeaderNav from '../components/sources/SourcesHeaderNav';
import SourcesCard from './sources/SourcesCard';
import SourcesStack from './sources/SourcesStack';
// css
import '../styles/containers/Sources.scss';


class Sources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openContributedCorrelationModalConfiguredItem: null
    };

    this.makeOpenContributedCorrelationModal = this.makeOpenContributedCorrelationModal.bind(this);
    this.closeContributedCorrelationModal = this.closeContributedCorrelationModal.bind(this);
    this.isContributedCorrelationModalOpen = this.isContributedCorrelationModalOpen.bind(this);
    this.canToggle = this.canToggle.bind(this);
  }

  // TODO: This state actually needs to hold the selected configured item
  // as soon as we have real data. Right now I've opted to make it a boolean
  // and show mock data in every instance of the modal.
  makeOpenContributedCorrelationModal(configuredItem) {
    return () => {
      this.setState({ openContributedCorrelationModalConfiguredItemId: configuredItem.id });
    };
  }

  closeContributedCorrelationModal() {
    this.setState({ openContributedCorrelationModalConfiguredItemId: null });
  }

  isContributedCorrelationModalOpen(configuredItem) {
    return this.state.openContributedCorrelationModalConfiguredItemId === configuredItem.id;
  }

  canToggle(areas) {
    return areas.length > 1;
  }

  render() {
    const {
      baseNavRoute,
      abilities,
      areas,
      area,
      dsa,
      subAreas,
      toggleBusinessArea,
      configuredItems,
      activeAreaIds,
      updateDSAConfiguredItem,
      changeDSAConfiguredItem,
      createCustomConfiguredItem } = this.props;

    const subArea = subAreas[0];

    return (
      <div className='sources'>
        <div className='container'>
          <section className='content-wrapper'>
            <SourcesHeader
              baseNavRoute={baseNavRoute}
              abilities={abilities}
              area={area}
              areas={areas}
              activeAreaIds={activeAreaIds}
              canViewTotalIndexed={abilities.canViewTotalIndexed}
              dsa={dsa}
            />
            {!area &&
              <div className='area-cards sources-cards'>
                {areas.map(area =>
                  (<SourcesCard
                    key={area.id}
                    area={area}
                    canViewTotalIndexed={abilities.canViewTotalIndexed}
                    dsa={dsa}
                    canActivateArea={abilities.canActivateArea(area)}
                    canToggle={this.canToggle(activeAreaIds)}
                    toggle={toggleBusinessArea}
                  />)
                )}
              </div>
            }
            {!!area &&
              <SourcesStack
                dsa={dsa.dsa}
                area={area}
                areas={areas}
                subArea={subArea}
                subAreas={subAreas}
                configuredItems={configuredItems}
                canEditEstimatedLogSize={abilities.canEditEstimatedLogSize}
                canEditPercentItemsIndexed={abilities.canEditPercentItemsIndexed}
                canEditPercentDataSourcesIndexed={abilities.canEditPercentDataSourcesIndexed}
                canViewTotalIndexed={abilities.canViewTotalIndexed}
                dsaConfiguredItems={dsa.dsaConfiguredItems}
                updateConfiguredItem={updateDSAConfiguredItem}
                changeConfiguredItem={changeDSAConfiguredItem}
                createCustomConfiguredItem={createCustomConfiguredItem}
                makeOpenContributedCorrelationModal={this.makeOpenContributedCorrelationModal}
                closeContributedCorrelationModal={this.closeContributedCorrelationModal}
                isContributedCorrelationModalOpen={this.isContributedCorrelationModalOpen}
                dsaExtensions={dsa.dsaExtensions}
              />
            }
            <SourcesHeaderNav
              area={area}
              areas={areas}
              dsa={dsa}
              activeAreaIds={activeAreaIds}
              baseNavRoute={baseNavRoute}
            />
          </section>
        </div>
      </div>
    );
  }
}

Sources.propTypes = {
  ...defaultPropTypes
};

export default dsaView(Sources);



// WEBPACK FOOTER //
// ./src/containers/Sources.js